import React from 'react';
import { Link } from 'react-router-dom';
import Badge from 'components/Badge';
import PictureImg from '../../common/PictureImg';
import { ROUTES_PREFIXES } from 'const';
import FormProductCard from './components/FormProductCard';
import { EmptyIcon } from './components/EmptyIcon';
import { getImgAlt } from 'utils/img';

import style from './styles/product_card.module.scss';

const ProductCard = ({ product }) => {
  const { slug } = product;
  const url = `${ROUTES_PREFIXES.PRODUCT}/${slug}`;
  return (
    <div className={style.product_card}>
      <Link className={style.product_card__image_link} to={url}>
        <div className={style.product_card__image_wrapper}>
          {product.image ? (
            <PictureImg
              src={product.image}
              webp={product.image_webp}
              alt={getImgAlt(product)}
              loading="lazy"
              className={style.product_card__image}
              width={280}
              height={180}
            />
          ) : (
            <EmptyIcon />
          )}

          <ul className={style.product_card__badges}>
            {product.badges.map((badge) => (
              <Badge key={badge} badgeType={badge} />
            ))}
          </ul>
        </div>
      </Link>

      <div className={style.product_card__info}>
        <span className={style.product_card__title}>{product.title}</span>
        <span className={style.product_card__article}>Артикул: {product.article}</span>
      </div>
      <FormProductCard
        minPrice={product.min_price}
        maxPrice={product.max_price}
        multiplicity={product.multiplicity}
        inPackCount={product.in_pack_count}
        minPackCount={product.min_pack_count}
        packageCountText={product.package_count_text}
        unitCountText={product.unit_count_text}
        packageCountHint={product.package_count_hint}
        article={product.article}
        inStock={product.in_stock}
      />
    </div>
  );
};

export default ProductCard;
